const Instagram = () => {
  return (
    <section className="instagram-cta">
      <div className="cta-content revelar zoom-in" >
          <img src="/imagenes/instagram.png" alt="Instagram" className="icono-flotante"/>                  
          <h2>¿Querés ver nuestros últimos trabajos?</h2>
          <p>Subimos fotos reales todos los días.</p>
          <a
            href="https://www.instagram.com/vaderservicios"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-instagram"
          >
            @VADERSERVICIOS
          </a>
      </div>
    </section>
  );
};
export default Instagram;